export interface ISettingsUserModel {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  middleName: string | null;
  role: SettingsUserRoleEnum;
  operatorId: string;
  fullName?: string;
}

export interface ISettingsUserCreatePayload {
  username: string;
  firstName: string;
  lastName: string;
  middleName: string | null;
  operatorId: string;
  role: SettingsUserRoleEnum;
}

export interface ISettingsUserUpdatePayload {
  firstName: string;
  lastName: string;
  middleName: string | null;
  operatorId: string;
  role: SettingsUserRoleEnum;
}

export enum SettingsUserRoleEnum {
  ADMIN = 1,
  OPERATOR = 2,
  SUPERADMIN = 3,
}

export const ISettingsUserRoleLabelMapper: Record<SettingsUserRoleEnum, string> = {
  [SettingsUserRoleEnum.ADMIN]: 'Админ',
  [SettingsUserRoleEnum.OPERATOR]: 'Оператор',
  [SettingsUserRoleEnum.SUPERADMIN]: 'Суперадмин',
};
